/**
 * Originals captured at module-evaluation time, before the blocking layer patches
 * anything. Everything internal must go through these — otherwise our own cookie
 * writes and record uploads would be caught by our own guards.
 *
 * This module must not import anything that has side effects.
 */

export const nativeCookieDescriptor: PropertyDescriptor | undefined =
  typeof Document !== "undefined"
    ? Object.getOwnPropertyDescriptor(Document.prototype, "cookie")
    : undefined;

export const nativeScriptSrc: PropertyDescriptor | undefined =
  typeof HTMLScriptElement !== "undefined"
    ? Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, "src")
    : undefined;

export const nativeIframeSrc: PropertyDescriptor | undefined =
  typeof HTMLIFrameElement !== "undefined"
    ? Object.getOwnPropertyDescriptor(HTMLIFrameElement.prototype, "src")
    : undefined;

export const nativeImageSrc: PropertyDescriptor | undefined =
  typeof HTMLImageElement !== "undefined"
    ? Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, "src")
    : undefined;

export const nativeLinkHref: PropertyDescriptor | undefined =
  typeof HTMLLinkElement !== "undefined"
    ? Object.getOwnPropertyDescriptor(HTMLLinkElement.prototype, "href")
    : undefined;

export const nativeSetAttribute: typeof Element.prototype.setAttribute | undefined =
  typeof Element !== "undefined" ? Element.prototype.setAttribute : undefined;

export const nativeFetch: typeof fetch | undefined =
  typeof window !== "undefined" && typeof window.fetch === "function"
    ? window.fetch.bind(window)
    : undefined;

export const nativeXhrOpen: typeof XMLHttpRequest.prototype.open | undefined =
  typeof XMLHttpRequest !== "undefined" ? XMLHttpRequest.prototype.open : undefined;

export const nativeSendBeacon: typeof navigator.sendBeacon | undefined =
  typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function"
    ? navigator.sendBeacon.bind(navigator)
    : undefined;

export function readCookieJar(): string {
  const get = nativeCookieDescriptor?.get;
  if (!get) return "";
  return String(get.call(document));
}

export function writeCookieJar(value: string): void {
  const set = nativeCookieDescriptor?.set;
  if (!set) return;
  set.call(document, value);
}
